import {
  Container, Box, Button
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useStyles } from './style';

import { dateFormat } from '../../utils/dateFormat';
import { ageCalculation } from '../../utils/generalFunc';

export const WelcomeProfile = () => {
  const classes = useStyles();
  const history = useHistory();
  const profile = useSelector((state) => state.profile.profilInfo);
  const allowDonorPhoto = useSelector((state) => state.profile.allowDonorPhotoUpload);
  const BirthDate = dateFormat(profile.Birthday);
  const getAge = ageCalculation(profile.Birthday);

  const continueClickHandler = () => {
    if (allowDonorPhoto) {
      history.push('/camera-view');
    } else {
      history.push('/personal-info');
    }
  };

  return (
    <Container maxWidth="md" className={classes.welcomeProfileContainer}>
      <Box className={classes.welcomeProfileContent}>
        <Box className={classes.profileDataWrap}>
          <Box className={classes.welcomeText}>Welcome</Box>
          <Box className={classes.profileName}>
            <Box component="span" className={classes.profileFirstName}>{profile.First} </Box >
            <Box component="span" className={classes.profileLastName}>{profile.Last}</Box>
          </Box>
          <Box className={classes.dobAgeText}>
            <Box className={classes.dobText}>{BirthDate}</Box>
            <Box className={classes.ageText}>(Age {getAge})</Box>
          </Box>
          <Box className={classes.courtText}>
            {profile.ProgramName}
          </Box>
        </Box>
        <Box className={classes.thanksParaWrap}>
          <Box component="p" className={classes.thanksHeadText}>Thanks for using our self-service registration portal.</Box>
          <Box component="p">
            The registration process should take about 10 minutes to complete, and you may be asked to take a photograph of yourself and your insurance card during the process.
          </Box>
          <Box component="p">
            Please ensure that you are in an appropriate location and have a copy of your insurance card with you.
          </Box>
        </Box>
        <Button onClick={continueClickHandler} className={classes.continueBtn} variant="contained" color="primary">
          Continue
        </Button>
      </Box>
    </Container >
  );
};
